module.exports = __webpack_public_path__ + "static/media/pack-en.15478b6d.png";